module.exports = __webpack_public_path__ + "media/images/emoticons/building-275ff685053ff0609bcba6172aae7f89.gif";